<app-toast></app-toast>
<app-replace-file-dialog></app-replace-file-dialog>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.file_upload' | transloco}}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.add_data' | transloco}}" [isActive]="true"
                    link="/file-upload/add"></app-tab-button>

            </div>

            <!-- Summary -->
            <div
                class="flex flex-wrap justify-between gap-6 mt-5 h-full max-w-ultrawide mobile:flex-col mobile:flex-nowrap mobile:p-2">
                <div
                    class="flex-[1] flex flex-col rounded-[16px] border-border border-[1px] p-5 min-w-[500px] mobile:min-w-[300px] mobile:w-full">
                    <h1 class="text-2xl text-black font-bold ">{{ 'shared.pages.file_upload' | transloco}}</h1>
                    <p class="text-base text-neutral-1200">{{ 'file_upload.offer' | transloco}}</p>

                    <!-- Upload button -->
                    <div class="w-full h-[20vh] min-h-[250px] mt-5">
                        <app-file-upload [toast]="toast"></app-file-upload>
                    </div>
                </div>

                <div
                    class="flex-[1] flex flex-col rounded-[16px] border-border border-[1px] p-5 min-w-[500px] mobile:min-w-[300px] mobile:w-full">
                    <h1 class="text-2xl text-black font-bold">{{ 'file_upload.recent_uploads' | transloco }}</h1>
                    <div class="h-[68vh] w-full overflow-y-auto mt-5">
                        <ng-container *ngFor="let uploadInfo of listOfRecentUploads; let i = index">
                            <app-uploaded-file [fileSrc]="uploadInfo.fileSrc" [fileName]="uploadInfo.fileName"
                                [fileSize]="uploadInfo.fileSizeMB" [currentValue]="uploadInfo.currentUploadProgress"
                                (stopClick)="stopClicked(i)" [canceled]="uploadInfo.canceled"></app-uploaded-file>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>